<template>
  <div class="printBox" v-if="_showPrintPage" v-loading="loading" element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.9)">
    <div style="text-align: right;padding: 20px;" v-if="user.deptName.includes('互联网')">
      <el-button type="primary" @click="adminPrint">打印</el-button>
    </div>
    <div class="printPage" ref="printAre">
      <h2 style="text-align: center">
        {{ $store.getters.viewPage.formName }}
      </h2>
      <img :src="effectiveIconUrl" alt=""
        style="position: absolute;top: 50px;right: 10px;z-index:999;pointer-events: none;" v-if="fieldData &&
          fieldData.Status && fieldData.Status === 'Effective'" ref="effectiveIcon">
      <el-row>
        <el-col v-for="(item, index) in field" :key="item.code + index" :span="item.parentId ? 12 : 24">
          <div class="itemInfo" v-if="item.name !== 'TableList'">
            <div class="title">{{ item.title }}</div>
            <div class="code">
              {{ setCodeName(formOptionInfo[item.code], item) }}
            </div>
          </div>
          <div v-else class="tableBox">
            <div style="
                text-align: center;
                border-left: 1px solid #c0c4cc;
                border-right: 1px solid #c0c4cc;
                line-height: 26px;
                color: #909399;
                font-weight: 500;
              ">
              {{ item.title }}
            </div>
            <el-table :data="formOptionInfo[item.code]" border style="width: 100%"
              :cell-style="{ borderColor: '#c0c4cc' }" :header-cell-style="{ borderColor: '#c0c4cc' }">
              <el-table-column v-for="column in item.items" :key="column.id" :label="column.title" :prop="column.code"
                min-width="20px">
                <template #default="{ row }">{{
                  setCodeName(row[column.code], column)
                  }}</template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
      <div style="
          text-align: center;
          border-left: 1px solid #c0c4cc;
          border-right: 1px solid #c0c4cc;
          line-height: 26px;
          color: #909399;
          font-weight: 500;
        " v-if="logList && logList.length > 0">
        流程日志
      </div>
      <el-table :data="logList" border style="width: 100%" v-if="logList && logList.length > 0"
        :cell-style="{ borderColor: '#c0c4cc' }" :header-cell-style="{ borderColor: '#c0c4cc' }">
        <el-table-column label="审批人" prop="executorName" align="center">
        </el-table-column>
        <el-table-column label="审批节点" prop="nodeName" align="center">
        </el-table-column>
        <el-table-column label="审批结果" prop="status" align="center" :formatter="(row, column, cellValue) =>
          cellValue === 'AGREE'
            ? '同意'
            : cellValue === 'CANCEL'
              ? '撤销'
              : cellValue === 'DELIVER'
                ? '转交'
                : cellValue === 'NO_EXECUTE'
                  ? '未执行'
                  : cellValue === 'REFUSE'
                    ? '拒绝'
                    : ''
          ">
        </el-table-column>
        <el-table-column label="审批时间" prop="started" align="center">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import print from "print-js";
import html2canvas from "html2canvas";
export default {
  name: "PrintPage",
  props: {
    showPrintPage: {
      type: Boolean,
      default: false,
    },
    pageNameList: {
      type: Array,
      default: () => [],
    },
    formOptionInfo: {
      type: Object,
      default: () => { },
    },
    logList: {
      type: Array,
      default: () => [],
    },
    fieldData: {
      type: Object,
      default: () => { },
    }
  },
  computed: {
    effectiveIconUrl() {
      // 跨域图片先预加载为 base64，避免 html2canvas 无法渲染
      if (this.effectiveIconBase64) return this.effectiveIconBase64;
      return 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/04/13/shenpitong-180456771.svg';
    },
    _showPrintPage: {
      get() {
        return this.showPrintPage;
      },
      set(val) {
        this.$emit("update:showPrintPage", val);
      },
    },
    field() {
      return this.$store.state.formData.field;
    },
    user() {
      return this.$store.getters.userInfo;
    }
  },
  data() {
    return {
      loading: true,
      effectiveIconBase64: '',
    };
  },
  mounted() {
    // 预加载跨域图片为 base64，避免 html2canvas 无法渲染
    this.loadImageAsBase64('https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/04/13/shenpitong-180456771.svg')
      .then(base64 => {
        this.effectiveIconBase64 = base64;
      })
      .catch(err => {
        console.error('预加载图片失败:', err);
      });
  },
  watch: {
    _showPrintPage(val) {
      if (val) {
        let focuser = setInterval(() => {
          window.dispatchEvent(new Event("focus"));
        }, 500);
        console.log(this.user, 1234)
        setTimeout(() => {
          this.generateCanvas(focuser);
        }, 300);
      }
    },
  },
  methods: {
    adminPrint() {
      let focuser = setInterval(() => {
        window.dispatchEvent(new Event("focus"));
      }, 500);

      setTimeout(() => {
        this.generateCanvas(focuser, false);
      }, 300);
    },
    loadImageAsBase64(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = reject;
        img.src = url;
      });
    },
    generateCanvas(focuser, isAdmin = true) {
      html2canvas(this.$refs.printAre, {
        allowTaint: false,
        useCORS: true,
        height: this.$refs.printAre.outerHeight,
        width: this.$refs.printAre.outerWidth,
        windowWidth: document.body.scrollWidth,
        windowHeight: document.body.scrollHeight,
      }).then((res) => {
        if (res) this.loading = false;
        if (this.user.deptName.includes('互联网') && isAdmin) return
        print({
          printable: res.toDataURL("image/png"),
          type: "image",
          style: `@media print { @page {size: auto; margin: 0; } body{margin:0 10px}}`,

          onPrintDialogClose: () => {
            this.$nextTick(() => {
              clearInterval(focuser);
              this._showPrintPage = false;
              this.loading = true;
            });
          },
        });
      });
    },
    setCodeName(info, item) {
      let res = Object.prototype.toString.call(info);
      if (
        ["[object String]", "[object Undefined]", "[object Number]"].includes(
          res
        )
      ) {
        if (item.name === "Signature") return "";
        else return info;
      } else if (res === "[object Array]") {
        let alisaArr = [
          "CreatedBy",
          "OwnerId",
          "UserPicker",
          "MultipleUserPicker",
        ];
        let nameArr = [
          "CreatedDept",
          "MultipleDeptPicker",
          "DeptPicker",
          "CreatedDept",
        ];
        if (alisaArr.includes(item.name))
          return info.reduce((pre, cur) => (pre += `${cur.alisa} `), "");
        if (nameArr.includes(item.name))
          return info.reduce((pre, cur) => (pre += `${cur.name} `), "");
        if (item.name === "MultipleRelevance")
          return info.reduce((pre, cur) => (pre += `${cur.Name} `), "");
        if (item.name === "MultipleSelect") return info.join(",");
      } else {
        if (item.name === "Relevance") return info.Name;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.el-table td,
.el-table th.is-leaf,
.el-table--border,
.el-table--group {
  border-color: #c0c4cc;
}

.el-table--border::after,
.el-table--group::after,
.el-table::before {
  background-color: #c0c4cc;
}

.printBox {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  background-color: #fff;
}

.printPage {
  width: 800px;
  margin: 0 auto;
  padding: 10px;
  overflow: auto;
  position: relative;
  height: 90vh;
}

.itemInfo {
  display: flex;
  border: 1px solid #c0c4cc;
  box-sizing: border-box;
  margin-right: -1px;
  margin-bottom: -1px;
  color: #909399;
  font-weight: 500;

  .title {
    width: 25%;
    border-right: 1px solid #c0c4cc;
    line-height: 26px;
    padding-left: 5px;
  }

  .code {
    padding-left: 5px;
    flex: 1;
    line-height: 26px;
  }
}

.tableBox {
  border-bottom: none;
}
</style>